import React from 'react';

export const APP_ROUTES = {
  home: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  setPassword: '/update_password',
  parentPortal: {
    base: '/parent',
    bookings: '/parent/bookings',
    calendar: '/parent/calendar',
    children: '/parent/children',
    medicalDietary: '/parent/medical-dietary',
    consents: '/parent/consents',
    incidents: '/parent/incidents-accidents',
    profile: '/parent/profile',
    terms: '/parent/terms-and-conditions',
    privacy: '/parent/privacy-and-communications',
  },
  calendar: '/calendar',
  eventsCalendar: '/events/calendar',
  contact: '/contact',
  documents: '/documents',
  competitions: {
    base: '/competitions',
    competition: (competitionId: number) => `/competitions/${competitionId}`,
  },
  teams: {
    base: '/teams',
    team: (teamId: number) => `/teams/${teamId}`,
  },
  standings: '/standings',
  about: '/about',
  articles: '/articles',
  news: {
    base: '/news',
    article: (slug: string) => `/news/${slug}`,
  },
  thankyou: '/thankyou',
} as const;

const AppRoutesContext = React.createContext(APP_ROUTES);

export type AppRoutes = typeof APP_ROUTES;

export function useAppRoutesContext(): AppRoutes {
  return React.useContext(AppRoutesContext);
}
